import { Button } from '@/components/ui/Button';
import { Tooltip } from '@/components/ui/Tooltip';

/** Asks the viewer's own Littlebird for a reply only they see; what is in the box steers it */
export function TeamChatDraftButton({
  onDraft,
  disabled,
}: {
  readonly onDraft: () => void;
  readonly disabled?: boolean;
}) {
  return (
    <Tooltip label="Drafts a reply only you can see. Type first to steer it.">
      <Button
        size="sm"
        variant="secondary"
        className="h-7 rounded-full px-3"
        textSize="xs"
        disabled={disabled}
        onClick={onDraft}
      >
        Draft
      </Button>
    </Tooltip>
  );
}
